import React from "react";
import { AiFillStar } from "react-icons/ai";
import { BiLogoGooglePlus } from "react-icons/bi";

export default function CardReview() {
  return (
    <div className="lg:w-5/6  sm:space-x-8 flex flex-col space-y-12 sm:space-y-0 sm:flex-row sm:justify-center lg:justify-end xl:justify-center ">
      <div className="space-y-5 p-7 sm:py-5 sm:px-7 shadow-xl 2xl:p-8  border-2 border-blue-200 rounded-xl lg:w-1/3 lg:h-auto    sm:w-1/2 sm:h-1/2 ">
        <div className=" flex items-center justify-center flex-col">
          <img
            className="2xl:w-20 2xl:h-20 rounded-full shadow-xl"
            src="assets/usergoogle1.png"
            alt=""
          />
          <div className="flex flex-col items-center space-y-1">
            <p className="text-2xl font-semibold">Yuyun Sahlan</p>
            <p className="text-xs ">Local Guide - Level 5</p>
          </div>
        </div>
        <p>
          "Tempatnya bersih, bagus.. Pelayanannya juga baik,,obat yg diberikan
          pun cocok. Terimakasih klinik Mora Medika Semoga semakin sukses”
        </p>
        <div className="flex items-center justify-between">
          <div className="flex text-yellow-400">
            <AiFillStar />
            <AiFillStar />
            <AiFillStar />
            <AiFillStar />
            <AiFillStar />
          </div>
          <BiLogoGooglePlus className="text-7xl text-gray-400" />
        </div>
      </div>

      <div className="space-y-5 p-7 sm:py-5 sm:px-7 shadow-xl 2xl:p-8  border-2 border-blue-200 rounded-xl lg:w-1/3 lg:h-auto    sm:w-1/2 sm:h-1/2  2xl:ml-12 ">
        <div className=" flex items-center justify-center  flex-col">
          <img
            className="2xl:w-20 2xl:h-20 rounded-full shadow-xl"
            src="assets/usergoogle2.png"
            alt=""
          />
          <div className="flex flex-col items-center space-y-1">
            <p className="text-2xl font-semibold">Puji Handhoko</p>
            <p className="text-xs ">Local Guide - Level 4</p>
          </div>
        </div>
        <p className="">
          "Klinik mora medika is the best lah pokoknya... Pelayanannya, krywn
          nya ramah, alhamdulillah mslh rujukan pun sya dijelaskan prosedurnya..
          Krn ada bbrp klinik yg ngerusak asal diagnosa aja. Klo sya pribadi lbh
          baik berobat d klinik biar g terppar sm virus n penyakit d RS yg lbh
          rentan terkena/menular pd kita..Tingkatkan trs pelayanannya... Smoga
          makin sukses bwt klinik mora medika”
        </p>
        <div className="flex items-center justify-between">
          <div className="flex text-yellow-400">
            <AiFillStar />
            <AiFillStar />
            <AiFillStar />
            <AiFillStar />
            <AiFillStar />
          </div>
          <BiLogoGooglePlus className="text-7xl text-gray-400" />
        </div>
      </div>
    </div>
  );
}
